export const transformObjIntoParams = (params: { [key: string]: unknown }) =>
  '?' +
  Object.entries(params)
    .map(([key, value]) => {
      //@ts-ignore
      if (key === 'search') return `${key}=${encodeURIComponent(value)}`
      return `${key}=${String(value)}`})
    .join('&');
